import React, { useContext, useEffect, useState } from "react";
import PopUpForm from "../../PopUp/PopUpForm";
import FormIngTeam from "../../Form/Engineer/FormIngTeam";
import moment from "moment";
import CardTeamUser from "./partials/CardTeamUser";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { StateRequest } from "../../../../router/PrivateRoutes";
import { ComService } from "../../../../services/ComService";
import { useAuth } from "../../../../services/useAuth";

const CardTeam = ({
  team,
  timeToRealod,
  dateDeVisiteEnabled,
  dateDeRenduEnabled,
}) => {
  const [showPopUp, setShowPopUp] = useState(false);
  const { setStateRequest } = useContext(StateRequest);
  const [medias, setMedias] = useState([]);

  const { role } = useAuth();

  const sendMessageToInterne = async (team) => {
    setStateRequest(["open", team.reference, "interne"]);
  };

  const getAdministrativeMedias = async () => {
    let request = await ComService.getProjectMedias(team.id);
    if (request.status === 200) {
      let medias = request.data["member"];

      let administrativeMedias = medias.filter(
        (media) => media.isAdministrative
      );

      setMedias(administrativeMedias);
    } else {
      toast.error("Une erreur est survenue");
    }
  };

  useEffect(() => {
    getAdministrativeMedias();
  }, [team]);

  //afficher les rôles
  const arrayRoleProject = [];
  team.ingAff ? arrayRoleProject.push("AFF") : null;
  team.ingDiag ? arrayRoleProject.push("DIAG") : null;
  team.ingChecker ? arrayRoleProject.push("VERIF") : null;
  team.ingAffExtra ? arrayRoleProject.push("AFF EXTRA") : null;
  team.ingDiagExtra ? arrayRoleProject.push("DIAG EXTRA") : null;
  team.ingCheckerExtra ? arrayRoleProject.push("VERIF EXTRA") : null;

  const rolesProjectString = arrayRoleProject.join(", ");

  //afficher les avatars
  const arrayPicturesVisit = [];
  team.ingDiag ? arrayPicturesVisit.push(team.ingDiag.urlAvatar) : null;
  team.ingDiagExtra
    ? arrayPicturesVisit.push(team.ingDiagExtra.urlAvatar)
    : null;
  const arrayPicturesDossierEtude = [];
  team.ingAff ? arrayPicturesDossierEtude.push(team.ingAff.urlAvatar) : null;
  team.ingAffExtra
    ? arrayPicturesDossierEtude.push(team.ingAffExtra.urlAvatar)
    : null;
  team.ingChecker
    ? arrayPicturesDossierEtude.push(team.ingChecker.urlAvatar)
    : null;
  team.ingCheckerExtra
    ? arrayPicturesDossierEtude.push(team.ingCheckerExtra.urlAvatar)
    : null;
  const arrayPicturesPri = [];
  team.ingAff ? arrayPicturesPri.push(team.ingAff.urlAvatar) : null;
  team.ingAffExtra ? arrayPicturesPri.push(team.ingAffExtra.urlAvatar) : null;

  const handleDownload = (url, filename) => {
    if (url !== undefined && filename !== undefined) {
      ComService.getProjectMedia(url, filename);
      toast.success("Téléchargement en cours");
    } else {
      toast.error("Une erreur est survenue");
    }
  };

  // On récupère le média "bill-quote" (le premier trouvé)
  const billQuoteMedia = medias.find(
    (media) => media.category === "bill-quote"
  );

  const VisiteMedia = medias.find(
    (media) => media.category === "reporting-notice"
  );

  const PriMedia = medias.find((media) => media.category === "media-pri");

  return (
    <>
      <article className="card-task">
        <div className="card-task-bloc">
          <div className="card-task-intro">
            <div className="card-task-intro-text">
              <h3 className="color-primary">
                <Link
                  to={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    `${team.address.street}, ${team.address.nicePostcode}, ${team.address.city}`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                >{`${team.address.street}, ${team.address.nicePostcode}, ${team.address.city}`}</Link>
                <div
                  className={"actions-controller"}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `${team.address.street}, ${team.address.nicePostcode}, ${team.address.city}`
                    );
                    toast.success("Adresse copié dans le presse-papier");
                  }}
                >
                  <img src={"/images/pictos/copy-paste.svg"} />
                </div>
              </h3>
              <p className="text-primary color-primary">
                {`${team.validQuoteServiceReferences.join(", ")}`}
              </p>
            </div>
          </div>
          <div className="card-task-people">
            <CardTeamUser
              pictures={arrayPicturesVisit}
              title={"Rapport de visite"}
            />
            <CardTeamUser
              pictures={arrayPicturesDossierEtude}
              title={"Validation du principe de structure"}
            />
            <CardTeamUser
              pictures={arrayPicturesPri}
              title={"Dossier d'étude structure"}
              link={`/dossier-etude/${team.study?.id}/redaction-du-dossier-etude`}
            />

            <button
              onClick={(e) => setShowPopUp(true)}
              style={{ width: "100%", boxSizing: "border-box" }}
              className="btn-default btn-default-primary color-primary"
            >
              Modifier les attributions
            </button>
          </div>

          <div className="card-task-content">
            <div className="card-task-content-line">
              <p className="text-primary color-primary">Nom client</p>
              <p className="text-primary color-primary paragraph_bold">
                <Link to={`/client/${team.client ? team.client.id : null}`}>
                  {team.client
                    ? team.client.niceNames
                    : team.client_first_name + " " + team.client_last_name}
                </Link>
                <div
                  className={"actions-controller"}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `${
                        team.client
                          ? team.client.niceNames
                          : team.client_first_name + " " + team.client_last_name
                      }`
                    );
                    toast.success(
                      "Le nom du client a été copié dans le presse-papier"
                    );
                  }}
                >
                  <img src={"/images/pictos/copy-paste.svg"} />
                </div>
              </p>
            </div>
            <div className="card-task-content-line">
              <p className="text-primary color-primary">Prix du projet HT</p>
              <p
                className={`text-primary color-primary paragraph_bold ${
                  billQuoteMedia ? "cursor-pointer underline" : ""
                }`}
                onClick={() =>
                  billQuoteMedia &&
                  handleDownload(
                    billQuoteMedia.downloadUrl,
                    billQuoteMedia.filename
                  )
                }
              >
                {team.totalValidQuote ? team.totalValidQuote.toFixed(2) : "N/A"}
                €
              </p>
            </div>
            <div className="card-task-content-line">
              <p className="text-primary color-primary">Numéro du projet</p>
              <p className="text-primary color-primary paragraph_bold">
                <Link to={`/projet/${team.id}`}>
                  {" "}
                  {team.reference ? team.reference : null}
                </Link>
                <div
                  className={"actions-controller"}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `${team.reference ? team.reference : null}`
                    );
                    toast.success(
                      "La référence a été copié dans le presse-papier"
                    );
                  }}
                >
                  <img src={"/images/pictos/copy-paste.svg"} />
                </div>
              </p>
            </div>
            <div className="card-task-content-line">
              <p className="text-primary color-primary">Date de visite</p>
              <p
                className={`text-primary color-primary paragraph_bold ${
                  VisiteMedia ? "cursor-pointer underline" : ""
                }`}
                onClick={() =>
                  VisiteMedia &&
                  handleDownload(VisiteMedia.downloadUrl, VisiteMedia.filename)
                }
              >
                {team.withVisit ||
                (!team.withVisit && team.visit?.valid === true) ? (
                  team.visit ? (
                    team.visit.valid ? (
                      <div className="text-align-right">
                        {`${moment(team.visit.startAt).format("DD/MM/YYYY")}`}
                        <br />
                        {`${moment(team.visit.startAt).format("H:mm")}-${moment(
                          team.visit.endAt
                        ).format("H:mm")}`}
                      </div>
                    ) : (
                      <div>Réservation ing.</div>
                    )
                  ) : (
                    <div>Réservation en cours</div>
                  )
                ) : (
                  <div>Pas de visite</div>
                )}
              </p>
            </div>

            <div className="card-task-content-line">
              <p className="text-primary color-primary">
                Date du principe de structure
              </p>
              <p
                className={`text-primary color-primary paragraph_bold ${
                  PriMedia ? "cursor-pointer underline" : ""
                }`}
                onClick={() =>
                  PriMedia &&
                  handleDownload(PriMedia.downloadUrl, PriMedia.filename)
                }
              >
                {team.startAt
                  ? moment(team.startAt).format("DD/MM/YYYY")
                  : "Pas de PRI"}
              </p>
            </div>

            <div className="card-task-content-line">
              <p className="text-primary color-primary">Date de rendu</p>
              <p className="text-primary color-primary paragraph_bold">
                {!team.study.estimatedEndAt
                  ? "N/A"
                  : moment(team.study.estimatedEndAt).format("DD/MM/YYYY")}
              </p>
            </div>

            {!role.includes("ROLE_ING_RES") && (
              <button
                type="button"
                className="button-send-message"
                title="Envoyer un message interne"
                onClick={() => sendMessageToInterne(team)}
              >
                Envoyer un message interne
              </button>
            )}
          </div>
        </div>
        <div className="card-task-improvement-status">
          <p className="text-primary color-dark-grey">
            {team.extendedStatus ?? team.niceStage}
          </p>
        </div>
      </article>
      {showPopUp ? (
        <PopUpForm
          onClick={() => setShowPopUp(false)}
          large={true}
          title={`${team.client.niceNames} - ${team.address.street}, ${team.address.nicePostcode}, ${team.address.city}`}
          form={
            <FormIngTeam
              setShowPopUp={setShowPopUp}
              team={team}
              timeToRealod={timeToRealod}
            />
          }
          show={showPopUp}
        />
      ) : null}
    </>
  );
};

export default CardTeam;
